import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-bold font-heading text-background-50 mb-4">
              {siteInfo.name}
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteInfo.description.slice(0, 100)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors text-background-200 hover:text-background-50"
                aria-label="Twitter"
                rel="nofollow"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors text-background-200 hover:text-background-50"
                aria-label="GitHub"
                rel="nofollow"
              >
                <i className="ri-github-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/pure-love" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                分类浏览
              </Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
              合规声明
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              本网站为内容导航与资讯推荐平台，不提供任何里番动漫内容的下载或在线观看服务。所有内容仅适合18岁以上成年用户浏览。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}